import React from "react";
import { forgotPassword, getUserData, login, PasswordRecoverData, Permission, setToken, setUserData, UserData } from "../../../api/authApi";
import './login.css'
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom';
import { Routes } from "../../../constants/routes";
import logo from "./../../images/logo.png";
import { TextBox } from "../../components/TextBox";
import { Title } from "../../components/Title";
import { Button } from "../../components/Button";
import { SmallModal } from "../../components/sideModal/Modal";

export type LoginState = { 
  login: string, 
  password: string,
  loginFailed: boolean,
  passwordError?: boolean,
  loginError?: boolean,
  remeberMe: boolean,
  switchToRestorePassword: boolean,
  passwordResetEmail: string,
  passwordResetError:boolean,
  showSuccessModal: boolean,
}

export interface LoginProps extends RouteComponentProps<any>
{
  setIsAuthorized : (isAuthorized: boolean) => void;
}

class Login extends React.Component<LoginProps, LoginState> {
    constructor(props: LoginProps) {
      super(props);  
      this.state = { 
        login: '', 
        password: '', 
        loginFailed: false, 
        remeberMe: false, 
        switchToRestorePassword: false,
        passwordResetEmail: '',
        passwordResetError: false,
        showSuccessModal: false,
      }    
    }

    // override async componentDidMount(){
    //   document.addEventListener('keypress', this.tryLoginByPressEnter)
    // }

    // override async componentWillUnmount(){
    //   document.removeEventListener('keypress', this.tryLoginByPressEnter)
    // }

    loginChange = (newValue: string) => {
      this.setState({login : newValue, loginFailed: false, loginError: false});
    }

    passwordChange = (newValue: string) => {
      this.setState({password : newValue, loginFailed: false, passwordError: false});
    }

    passwordResetEmailChange = (newValue: string) => {
      this.setState({passwordResetEmail : newValue, passwordResetError: false});
    }



    remeberMeClick = (event: React.MouseEvent<HTMLInputElement>) => { 
        var checked = event.currentTarget.checked;
        this.setState({remeberMe : checked});
    };


    
    hasPermission = (userData: UserData, permission: Permission) => {
      return userData.permissions.findIndex(i => i == permission) !== -1;
    }

    getDefaultRoute = () => {
      var userData = getUserData();
      if(this.hasPermission(userData, Permission.ExternalOrganisationUser)) return Routes.Campaigns;
      if(this.hasPermission(userData, Permission.Dashboard)) return Routes.Dashboard;
      if(this.hasPermission(userData, Permission.PlayNowList)) return Routes.PlayNow;
      if(this.hasPermission(userData, Permission.PriorityList)) return Routes.PriorityList;
  
      return Routes.Reports;
    }

    tryLogin = async () => {
        let isValid = true;
        if(this.state.login === '') { this.setState({loginError: true}); isValid = false ; }
        if(this.state.password === '') { this.setState({passwordError: true}); isValid = false; }

        if(!isValid) return;

        var result = await login({password: this.state.password, login : this.state.login})
        if(result.result == 'fail'){
          this.setState({loginFailed : true});
          return;
        }
        
        let userData: UserData = {
          name: result.name,
          permissions: result.permissions,
          profilePicture: result.profilePicture
        }

        setUserData(userData, this.state.remeberMe ? "persistent" : "session");
        setToken(result.token, this.state.remeberMe ? "persistent" : "session");
        this.props.setIsAuthorized(true);
        this.props.history.push(this.getDefaultRoute());
    }

    tryLoginByPressEnter = (event: React.KeyboardEvent<HTMLDivElement>) => {
      if(event.key === "Enter") this.tryLogin()
    }

    goToForgotPasswordForm = () => {
      this.setState({switchToRestorePassword:true})
    }

    tryResetPassword = async () => {
      let isValid = true;
      if(this.state.passwordResetEmail === '') { this.setState({passwordResetError: true}); isValid = false ; }

      if(!isValid) return;

      let passwordRecoverData: PasswordRecoverData = {
        email: this.state.passwordResetEmail
      }

      //send email here
      let result = await forgotPassword(passwordRecoverData);

      if( result.result == "success"){
        this.setState({passwordResetEmail:'',showSuccessModal:true})
      }
    }

    closeSuccessModal = () => this.setState({showSuccessModal:false, switchToRestorePassword: false})

    
    render() {
      return <div className="loginWrapper" onKeyDown={this.tryLoginByPressEnter}>
                  <div className="left_column">
                      <div className="logo">
                        <img src={logo}></img>
                      </div>
                  </div>
                  <div className="right_column">
                    {!this.state.switchToRestorePassword && 
                    <div className="login_form">
                      <Title text="Sign in to CSCREENS Content Management System"/>
                      <TextBox onChange={this.loginChange} type="text" label="Email Address" isError={this.state.loginError}/>
                      <TextBox onChange={this.passwordChange} type="password" label="Password" isError={this.state.passwordError}/>
                      
                      {this.state.loginFailed && <div className="error_message">Wrong password or email.</div>}                      
                      
                      <div className="forgot_block">
                        <span className="forgot_link" onClick={this.goToForgotPasswordForm}>Forgot Password?</span>
                      </div>

                      <div className="btn_form">
                        <label>                          
                          <input type="checkbox" onClick={this.remeberMeClick}></input>
                          Remember me
                        </label>
                        <Button onClick={this.tryLogin} label="Login" type="login" color="white" />
                      </div>
                    </div> 
                    }

                    {this.state.switchToRestorePassword && 
                    <div className="login_form">
                      <Title text="Reset password"/>
                      <TextBox onChange={this.passwordResetEmailChange} type="text" label="Email Address" isError={this.state.passwordResetError}/>

                      <div className="btn_form">
                          <Button onClick={this.tryResetPassword} label="Send" type="login" color="white" />
                      </div>
                    </div> 
                    }
                                       
                  </div>
                  <SmallModal text="Thanks!" show={this.state.showSuccessModal} onRequestClose={this.closeSuccessModal}> 
                        <p>Please check your email</p>
                        <div className="modal-btn-group center">
                            <Button color="gray" label="Close" onClick={this.closeSuccessModal}/>
                        </div>
                  </SmallModal>
            </div>
    }
  }

export default withRouter(Login);
